"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _emitter = _interopRequireDefault(require("../emitter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Registers a callback to the given event name.
 * @param {string} event The event name.
 * @param {Function} callback The callback to register.
 */
var addCallback = function addCallback(event, callback) {
  if (typeof callback === 'function') {
    _emitter["default"].addListener(event, callback);
  }
};

var _default = addCallback;
exports["default"] = _default;